<template>
    <v-text-field
        v-model="displayValue"
        :label="label"
        :prefix="prefix"
        @blur="isInputActive = false" 
        @focus="isInputActive = true"
    ></v-text-field>
</template>

<script>
export default {
    props: ["label", "value", "prefix"],
    data: () => {
        return {
            isInputActive: false
        }
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.isInputActive) {
                    return this.value.toString()
                } else {
                    return this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                }
            },
            set: function(modifiedValue) {
                let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ""))
                if (isNaN(newValue)) {
                    newValue = 0
                }
                this.$emit('input', newValue)
            }
        }
    }
}
</script>

<style>

</style>